export enum ButtonStyle {
  OUTLINED = "outlined",
  FILLED = "filled",
}

export enum ButtonCornerStyle {
  SHARP = "sharp",
  SLIGHTLY_ROUNDED = "slightly_rounded",
  ROUNDED = "rounded",
  FULLY_ROUNDED = "fully_rounded",
}

export type Theme = {
  accentColor: string
  inverseAccentColor: string
  delayedCtaChatAccentColor: string
  textCtaColor: string
  neutralTextColor: string
  promptButtonColor: string
  modalBackgroundColor: string
  containerMaxWidth: string
  modalPadding: string
  legacyPromptHeadingColor: string
  legacyPromptIconColor: string
  //  Positioning
  widgetBottomOffset: string | null
  leftAlign: boolean
  //  Legacy Trade-In Prompt specific
  sharpCorners: boolean
}
